import { sbEditable } from '@storyblok/storyblok-editable'
import * as React from 'react'
import { ButtonModule } from "../../modules/Button";
import styled, { css } from 'styled-components'
import { TitleWithPrefix } from '../../components/UI/TitleWithPrefix'
import { containerDefault } from '../../lib/styles/Container'
import { Columns } from './Columns'
import { TeaserCardGridProps } from './types'
import { ThemeName } from '../../lib/constants';

const ModuleWrapper = styled.div<{ $marginBlock?: string }>`
  ${containerDefault}
  margin-inline: auto;
  margin-block: ${p => p.$marginBlock || '2rem'};
`

const ModuleContainer = styled.div<{
  $align?: 'left' | 'center'
  $mediumCenterMargin: string
  $smallCenterMargin: string
  $mediumLeftMargin: string
  $smallLeftMargin: string
  $borderRadius?: string
  $theme?: ThemeName
  $marginBlock?: string
  $padding?: string
}>`
  ${containerDefault}
  margin-inline: auto;
  border-radius: 1rem;
  padding: ${p => p.$padding || '2rem'};
  background-color: ${({ theme, $theme }) => !$theme ? theme.colors.black[7] : theme.colors[$theme][7]};
   margin-block: ${p => p.$marginBlock || '2rem'};
  ${p => p.$borderRadius ? css`
    border-radius: ${p.$borderRadius};
  ` : 'border-radius: 1rem;'}

  @media screen and (max-width: 768px) {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

const ButtonContainer = styled.div`
  ${containerDefault}
  margin-inline: auto;
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  align-content: center;
`;

export const TeaserCardGrid = ({ blok }: TeaserCardGridProps) => {
  const { isSlider, buttons, noBorder } = blok

  const headlineSize = blok.headlineSize ? blok.headlineSize : 'small'
  const blokAlignment = blok.alignment ? blok.alignment : 'left'

  const mediumCenterMargin = headlineSize === 'medium' && blokAlignment === 'center' ? '3rem' : ''
  const smallCenterMargin = headlineSize === 'small' && blokAlignment === 'center' ? '2.5rem' : ''
  const mediumLeftMargin = headlineSize === 'medium' && blokAlignment === 'left' ? '1.5rem' : ''
  const smallLeftMargin = headlineSize === 'small' && blokAlignment === 'left' ? '1rem' : ''

  return (
    <ModuleWrapper {...sbEditable(blok)} $marginBlock={blok.marginBlock}>
      {!!blok.title && !isSlider && (
        <TitleWithPrefix
          title={blok.title}
          headlineSize={blok.headlineSize}
          textAlign={blok.alignment}
          headlineType={blok.headlineSyntax}
          subline={blok.subline}
          sublineSize={blok.sublineSize}
        />
      )}
      <ModuleContainer
        $mediumCenterMargin={mediumCenterMargin}
        $smallCenterMargin={smallCenterMargin}
        $mediumLeftMargin={mediumLeftMargin}
        $smallLeftMargin={smallLeftMargin}
        $align={blok.alignment}
        $theme={blok.theme}
        $borderRadius={blok.borderRadius}
        $marginBlock={blok.marginBlock}
        $padding={blok.padding}
      >

        <Columns blok={blok} $align={blok.alignment} $width={blok.width} />
        {buttons && (
          <ButtonContainer>
            {buttons.map((button) => (
              <ButtonModule key={button._uid} blok={button} />
            ))}
          </ButtonContainer>
        )}
      </ModuleContainer>
    </ModuleWrapper>
  )
}
